<template>
  <v-dialog v-model="showWindow" scrollable max-width="90%">
    <v-card>
      <v-card-actions>
        <h3 class="pl-2">
          {{ partNumber }}: {{ $t("applicabilityWindow.applicability") }}
        </h3>
        <v-spacer></v-spacer>
        <v-btn icon @click="showWindow = false">
          <v-icon>fa-times</v-icon>
        </v-btn>
      </v-card-actions>
      <v-divider></v-divider>
      <div v-if="isLoadingApplicability" class="text-xs-center pa-5">
        <v-progress-circular
          size="64"
          indeterminate
          color="primary"
          className="mx-auto d-block"
        ></v-progress-circular>
      </div>
      <v-card-text v-if="!applicabilityCar && !isLoadingApplicability">
        <v-layout row wrap pa-2 flex-start>
          <v-flex>
            <div v-for="catalogData in applicabilityCars" class="mb-5">
              <h3 v-if="catalogData['catalog_name']" class="mb-2">
                {{ catalogData["catalog_name"].toUpperCase() }}
              </h3>
              <v-expansion-panels>
                <v-expansion-panel v-for="family in catalogData.families">
                  <v-expansion-panel-header>
                    <h4>{{ family["family_name"] }}</h4>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <div v-for="model in family['models']">
                      <h5 class="text-xs-center">{{ model["model_name"] }}</h5>
                      <v-data-table
                        :headers="applicabilityCarsTableHeader(model['modifs'])"
                        class="w-100"
                        :items="model['modifs']"
                        :footer-props="{
                          'items-per-page-text': $t('tables.items_per_page'),
                          'items-per-page-options': [
                            10, 50, 100,
                            //-1
                          ],
                        }"
                      >
                        <template v-slot:footer.page-text="props">
                          {{
                            $t("tables.x_of_y", [
                              `${props.pageStart}-${props.pageStop}`,
                              props.itemsLength,
                            ])
                          }}
                        </template>
                        <template v-slot:item="props">
                          <tr>
                            <template v-for="(item2, i) in props.item.props">
                              <template v-if="props.item.modif_link != item2">
                                <td
                                  :title="props.item.link"
                                  class="pointer text-no-wrap"
                                >
                                  {{ item2 }}
                                </td>
                              </template>
                            </template>
                          </tr>
                        </template>
                        <template v-slot:no-data>
                          {{ $t("common.no_data_available") }}
                        </template>
                        <template v-slot:no-results>
                          {{ $t("common.no_data_available") }}
                        </template>
                      </v-data-table>
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </div>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-text
        class="ma-0 pa-0"
        v-if="
          applicabilityCar && !applicabilityCar.error && !isLoadingApplicability
        "
      >
        <v-layout row>
          <v-flex class="px-0" shrink>
            <v-btn icon @click.stop="applicabilityCar = null">
              <template>
                <v-icon>chevron_left</v-icon>
              </template>
            </v-btn>
          </v-flex>
          <v-flex align-self-center class="px-0" grow>
            <h3>
              {{ applicabilityCar.catalog_name.toUpperCase() }}
              {{ applicabilityCar.family_name }}
              {{ applicabilityCar.model_name }}
            </h3>
          </v-flex>
        </v-layout>
        <v-layout row wrap pa-2 flex-start>
          <v-flex>
            <template v-for="node in applicabilityCar.nodes">
              <v-flex cols="6" class="ma-0 pa-0 pl-4 pr-4">
                <h4 class="px-1">{{ node.node_name }}</h4>
                <v-layout row wrap class="mb-3">
                  <v-flex xs12 sm6>
                    <img
                      @click="applicabilityGoToCar(node)"
                      :src="node.image"
                      class="applicabilityImg"
                    />
                  </v-flex>
                  <v-flex xs12 sm6>
                    <template v-for="(one, index3) in node.parts">
                      <v-layout
                        row
                        wrap
                        class="ma-0 text-sm-no-wrap"
                        :key="index3"
                      >
                        <v-flex xs12 sm11 class="px-0 mx-0" align-self-center>
                          <v-layout row wrap>
                            <v-flex
                              xs12
                              class="px-0 mx-0"
                              align-self-center
                              @click="applicabilityGoToCar(node)"
                            >
                              <span class="pointer"
                                >{{ one.part_name }}, pnc: {{ one.pnc }}
                              </span>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </template>
                  </v-flex>
                </v-layout>
              </v-flex>
            </template>
          </v-flex>
        </v-layout>
      </v-card-text>

      <v-card-text
        class="ma-0 pa-0"
        v-if="
          applicabilityCar && applicabilityCar.error && !isLoadingApplicability
        "
      >
        <v-layout row>
          <v-flex class="px-0" shrink>
            <v-btn icon @click.stop="applicabilityCar = null">
              <template>
                <v-icon>chevron_left</v-icon>
              </template>
            </v-btn>
          </v-flex>
        </v-layout>
        <v-alert
          dense
          outlined
          type="error"
          class=""
          :value="!isLoadingApplicability && applicabilityCar.error != ''"
        >
          {{ applicabilityCar.error }}
        </v-alert>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import CommonMixin from "@/mixins/common";
import CalendarMixin from "@/mixins/calendar";
import BeautyCarNumber from "../common/BeautyCarNumber";

export default {
  name: "ApplicabilityWindow",
  components: { BeautyCarNumber },
  mixins: [CommonMixin, CalendarMixin],
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    partNumber: {
      type: String,
      default: null,
    },
  },
  data: () => ({}),
  computed: {
    ...mapFields("applicability", [
      "applicabilityCars",
      "isLoadingApplicability",
      "applicabilityCar",
    ]),
    showWindow: {
      get() {
        return this.show;
      },
      set() {
        this.$emit("hide");
      },
    },
    cal() {
      return this.ready ? this.$refs.calendar : null;
    },
  },
  mounted() {
    this.ready = true;
  },
  methods: {
    applicabilityCarsTableHeader(data) {
      if (typeof data !== "undefined") {
        let arr = Object.entries(data[0].props);
        if (arr.length) {
          let res = arr
            .map((item) => {
              if (item[0] !== "link") {
                return { text: item[0], value: item[0], sortable: false };
              }
            })
            .filter((item) => {
              if (item !== undefined) return true;
            });
          return res;
        }
      }
      return [];
    },
  },
  watch: {
    show(to, from) {
      if (to) {
        this.$store.dispatch("applicability/fetchApplicability1", {
          part_code: this.partNumber,
        });
      }
    },
  },
};
</script>
